import type Enums from '@core/types/api/Enums';
import type { ImportedDiscount } from '@core/types/api/ImportedDiscount/ImportedDiscount';
import { hasStringValue } from '@core/utils/equality';

import { useSlabQuery } from './useSlabQuery';

type Args = {
  companyID: string | null;
  productID: string;
  deliveryType: Enums.ProductDeliveryType | null;
  enabled?: boolean;
};

export const useMatchingDiscounts = ({
  companyID,
  productID,
  deliveryType,
  enabled = true,
}: Args): {
  discounts: ImportedDiscount[];
  isSuccess: boolean;
  isLoading: boolean;
  isError: boolean;
} => {
  const {
    data: discounts = [],
    isSuccess,
    isLoading,
    isError,
  } = useSlabQuery(
    'GET matching imported discounts',
    {
      queryParams: {
        companyId: companyID ?? '',
        productId: productID,
        deliveryType: deliveryType ?? '',
      },
    },
    { enabled: enabled && hasStringValue(companyID) && hasStringValue(productID) },
  );

  return { discounts, isSuccess, isLoading, isError };
};
